import cn from 'classnames';

import { ComponentProps } from '../../../types/component-props';
import { CoreSearchData } from '../../../types/components';
import SearchBar from './components/SearchBar';
import SearchPagination from './components/SearchPagination';
import SearchResults from './components/SearchResults';
import { usePageSearch, PAGE_ITEM_COUNT } from './usePageSearch';

import styles from './CoreSearch.module.scss';

export type CoreSearchProps = ComponentProps & CoreSearchData;

const CoreSearch = ({ fields }: CoreSearchProps): JSX.Element => {
  const { adjustPage, formRef, onSubmit, clearField, data } = usePageSearch();

  const {
    termInputPlaceholderLabel,
    emptyStateLabel,
    noResultsFoundLabel,
    resultCountLabel,
    paginationLabelPrevious,
    paginationLabelNext,
    searchInputLabel,
  } = fields;

  const resultLabels = {
    resultLabels: {
      emptyStateLabel,
      noResultsFoundLabel,
      resultCountLabel,
    },
    paginationLabels: {
      paginationLabelPrevious,
      paginationLabelNext,
    },
  };

  const showPagination = (data?.total ?? 0) > PAGE_ITEM_COUNT && (data?.results ?? []).length > 0;

  const handleClear = () => {
    clearField('term', true);
  };

  return (
    <section className={cn(styles.search, 'spacer', 'spacer--solid')}>
      <search className={styles.searchWrapper}>
        <div className={cn('container', 'container--true-1440')}>
          <SearchBar
            ref={formRef}
            onSubmit={onSubmit}
            onClear={handleClear}
            className={styles.searchBar}
            labels={{ termInputPlaceholderLabel, searchInputLabel }}
          />
        </div>
      </search>
      <div className={cn('container', 'container--true-1440')}>
        <SearchResults searchResults={data} labels={resultLabels} />
        {showPagination && (
          <SearchPagination
            adjustPage={adjustPage}
            totalResults={data?.total ?? 0}
            labels={resultLabels.paginationLabels}
          />
        )}
      </div>
    </section>
  );
};

export default CoreSearch;
